module.exports = __webpack_public_path__ + "assets/block-icon.b92af02b.svg";